var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.95q-3.05-.35-5.025-2.625Q2 17.05 2 13.8q0-2.5 1.988-5.437Q5.975 5.425 10 2q4.025 3.425 6.012 6.363Q18 11.3 18 13.8v.2h-2v-.2q0-1.825-1.512-4.125Q12.975 7.375 10 4.65 7.025 7.375 5.513 9.675 4 11.975 4 13.8q0 2.425 1.4 4.1 1.4 1.675 3.6 2.025Zm1-9.675ZM11 22v-6h3.5q.6 0 1.05.45.45.45.45 1.05v1q0 .6-.45 1.05-.45.45-1.05.45h-2v2Zm6 0v-6h1.5v2h2v-2H22v6h-1.5v-2.5h-2V22Zm-4.5-3.5h2v-1h-2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.3221fb1b93573c38c4e53522173e709a.svg";
export { ForwardRef as ReactComponent };